// removed by extract-text-webpack-plugin
module.exports = {"titlebar":"options-titlebar__titlebar___309MK"};


//////////////////
// WEBPACK FOOTER
// ../stylesheet/css/header-builder/options-titlebar.css
// module id = 537
// module chunks = 0